import React from 'react'
export default function NewsCards({newstitle=".....",newstext="....",newsurl,newsimg}) {
  return (
    <div className="col-md-4 my-2">
    <div className="card" style={{width: "18rem", height: "25rem"}}>
        <img src={newsimg} style={{ height: "200px",objectFit:"cover"}}className="card-img-top" alt="..."/>
        <div className="card-body d-flex flex-column">
          <div className="all_Content" style={{ overflow: "scroll", textOverflow: "ellipsis", height: "calc(25rem - 300px)" }}>
            <h5 className="card-title">{!newstitle ? "" :newstitle.split(" ").slice(0, 10).join(" ")+"..."}</h5>
            <p className="card-text">{!newstext ? "" : newstext.split(" ").slice(0, 10).join(" ")+"...."}</p>
          </div>
            <a href={newsurl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary mt-auto">Read More</a>
        </div>
    </div>
    </div>
  )
}
